var map = {
	"./YaP.jpg": 28190,
	"./ahmad.jpg": 57428,
	"./dacha.jpg": 94875,
	"./fast.jpg": 98048,
	"./film.jpg": 21590,
	"./green.jpg": 96480,
	"./gryadka.jpg": 14153,
	"./harry.jpg": 719,
	"./hits.jpg": 54077,
	"./hochland.jpg": 92275,
	"./hp.jpg": 16230,
	"./kids.jpg": 15084,
	"./march.jpg": 1721,
	"./marchgifts.jpg": 41852,
	"./maslenitsa.jpg": 55306,
	"./maxim.jpg": 95572,
	"./ny.jpg": 10984,
	"./odyssey.jpg": 34779,
	"./romantic.jpg": 44883,
	"./school.jpg": 73329,
	"./sweet.jpg": 82870
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41498;